import * as variables from './variables.js';

import "./site/Analytics";

import './index-previous';

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import MegaMenu from './site/MegaMenu';
MegaMenu();

import './site/InspirationGallery'; // Self initializes
import './site/InspirationGalleryAnnotations'; // Self initializes

import SectionAside from './site/SectionAside';
SectionAside();

import Anniversary from './site/Anniversary';
Anniversary();

import VideoModal from './site/VideoModal';
VideoModal();

import HomepageVideoVisibility from './site/HomepageVideoVisibility';
HomepageVideoVisibility();

import DPPManager from './site/CookiePolicy';
new DPPManager();

import DetailSummaryGroup from '../component/DetailSummaryGroup';
new DetailSummaryGroup();

